<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group label="Nome" label-for="v-name">
                <b-form-input
                  id="v-name"
                  v-model="eventType.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="nome"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!eventType.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') && !eventType.id)
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <b-form-group label="Evento Recorrente">
              <b-form-checkbox v-model="eventType.recorrente" switch>
                {{ eventType.recorrente ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="eventType.recorrente">
            <b-form-group label="Regra Início (1º Lançamento)">
              <v-select
                v-model="eventType.regraPrimeiraMensalidade"
                :options="['INTEGRAL', 'PROPORCIONAL', 'PROXIMO_MES']"
                @input="eventType.temProRata = (eventType.regraPrimeiraMensalidade === 'PROPORCIONAL')"
                placeholder="Selecione a regra"
              />
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="eventType.recorrente">
            <b-form-group label="Dia Limite" description="Até este dia a cobrança é no mês atual (ou integral se Pro-rata)">
              <b-form-input type="number" v-model="eventType.diaLimiteProRata" min="1" max="31" />
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="eventType.recorrente">
            <b-form-group label="Dia Vencimento Padrão">
              <b-form-input type="number" v-model="eventType.diaVencimentoPadrao" min="1" max="31" />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Ativo">
              <b-form-checkbox
                v-model="eventType.ativo"
                switch
                inline
              >
                {{ eventType.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import mixinsGlobal from "@/mixins";
import { verificarPermissao } from "@/auth/utils";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("eventTypeSettingsModule", {
      eventType: (state) => state.eventType,
    }),
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      verificarPermissao,
      titleForm: "Cadastro de Tipo de Evento",
      required,
      eventTypePlace: {
        nome: "",
        ativo: true,
      },
    };
  },
  mounted() {
    this.eventTypePlace = JSON.parse(JSON.stringify(this.eventType));
  },
  methods: {
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch("eventTypeSettingsModule/resetEventType");
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.eventType.id) {
            this.$store
              .dispatch("eventTypeSettingsModule/editEventType", this.eventType)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Editar",
                    response.response.data.error
                  );
                  return;
                }
                this.showMessageSuccess("Editar", "Editado com sucesso!");
                this.$refs.form.reset();
                this.cancel();
              });
          } else {
            this.$store
              .dispatch(
                "eventTypeSettingsModule/insertNewEventType",
                this.eventType
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Inserir",
                    response.response.data.error
                  );
                  return;
                }
                this.showMessageSuccess("Salvo", "Incluido com sucesso!");
                this.cleanObjeto();
                this.$store.dispatch("eventTypeSettingsModule/resetEventType");
                this.$refs.form.reset();
              });
          }
        }
      });
    },
    cleanObjeto() {
      this.eventTypePlace = {
        nome: "",
        ativo: true,
      };
    },
  },
};
</script>
